export default defineNuxtPlugin((nuxtApp) => {

  nuxtApp.hook('vue:error', (error, instance, info) => {
    useBugsnag().notify(`Error hunter: ${error}`)
  });
});